import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the tableInformeGerencialView.
 * @extends JetView
 */
export default class tableInformeGerencialView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);

        /**
         * Formats a value as a percentage string.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%';
        }

        // Extend the summTreeColumn filter with custom refresh logic
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the display of the summary tree column.
                 * @param {Object} master - The master data view.
                 * @param {Object} node - The node to refresh.
                 * @param {Object} value - The value containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result accumulator
                    var resultFormat = 0; // Initialize formatted result

                    // Iterate through each object in the master data
                    master.data.each(function (obj) {
                        // Sum values for objects at level 1
                        if (obj.$level == 1) result += obj[value.columnId];
                    });

                    // Format the result based on the columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        if (value.columnId === 'GgrPorc') {
                            resultFormat = webix.i18n.numberFormat(result) + '%';
                        } else {
                            resultFormat = webix.i18n.priceFormat(result);
                        }
                    }
                    // Update the inner HTML of the node with the formatted result
                    node.firstChild.innerHTML = resultFormat;
                },
            },
            webix.ui.datafilter.summColumn, // Extend from the existing summColumn filter
        );

        // Return the configuration for the UI component
        return {
            rows: [
                {
                    id: 'preloader', // Identifier for the preloader row
                    cols: [
                        {
                            view: 'treetable', // Define a tree table view
                            id: 'AgentInform', // Identifier for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border informeGerencial', // CSS classes for styling
                            // Function to open all rows in the tree table
                            bready: function () {
                                this.openAll();
                            },
                            footer: false, // Disable footer
                            scroll: true, // Enable scrolling
                            columns: [
                                {
                                    id: 'Pais', // Identifier for the country column
                                    header: _('País'), // Header label for the column
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 250, // Column width
                                    // Template function to display group or country name
                                    template: function (obj, common) {
                                        if (obj.$group) return common.treetable(obj, common) + obj.value;
                                        return obj.Pais;
                                    },
                                },
                                {
                                    id: 'Afiliator', // Identifier for the affiliate column
                                    header: _('Afiliador'), // Header label for the column
                                    width: 150, // Column width
                                },
                                {
                                    id: 'UserId', // Identifier for the user ID column
                                    header: _('ID Usuario'), // Header label for the column
                                    width: 100, // Column width
                                },
                                {
                                    id: 'User', // Identifier for the user column
                                    header: _('Usuario'), // Header label for the column
                                    width: 150, // Column width
                                },
                                { id: 'Date', header: _('Fecha'), width: 150 }, // Identifier for the date column
                                {
                                    id: 'Moneda', // Identifier for the currency column
                                    header: _('Moneda'), // Header label for the column
                                    width: 150, // Column width
                                },
                                {
                                    id: 'CantidadTickets', // Identifier for the ticket count column
                                    header: _('Cantidad Tickets'), // Header label for the column
                                    format: webix.i18n.intFormat, // Formatting function for integer values
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Stake', // Identifier for the stake column
                                    header: _('Stake'), // Header label for the column
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'StakePromedio', // Identifier for the average stake column
                                    header: _('Stake Promedio'), // Header label for the column
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Payout', // Identifier for the payout column
                                    header: _('Payout'), // Header label for the column
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Bonos', // Identifier for the bonuses column
                                    header: _('Bonos'), // Header label for the column
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Ggr', // Identifier for the GGR column
                                    header: _('GGR'), // Header label for the column
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'GgrPorc', // Identifier for the GGR percentage column
                                    header: _('GGR %'), // Header label for the column
                                    format: percentFormat, // Formatting function for percentage values
                                    width: 200, // Column width
                                },
                            ],
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable mathematical operations
                            datafetch: 10, // Number of data items to fetch at once
                            pager: 'pagerA', // Identifier for the pager component
                            // API URL for fetching data
                            url: devConfig.geturlApi() + 'es/Agents/GetInformeGerencial',
                            leftSplit: 3, // Number of columns to keep fixed on the left
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Attach an event handler for when the grid has finished loading data
        grid.attachEvent('onAfterLoad', function () {
            // Group data in the grid by 'Afiliator'
            $$('AgentInform').data.group({
                by: 'Afiliator',
                map: {
                    // Define how to aggregate data for each field
                    Afiliator: ['Afiliator'],
                    Pais: ['Pais'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    Stake: ['Stake', 'sum'],
                    StakePromedio: ['StakePromedio', 'sum'],
                    Payout: ['Payout', 'sum'],
                    Bonos: ['Bonos', 'sum'],
                    Ggr: ['Ggr', 'sum'],
                    // Custom aggregation for GgrPorc
                    GgrPorc: [
                        'GgrPorc',
                        function (prop, data) {
                            // Return 0 if no data is available
                            if (!data.length) return 0;
                            var summ1 = 0; // Sum for Stake
                            var summ2 = 0; // Sum for Ggr
                            // Iterate through data to calculate sums
                            for (var i = data.length - 1; i >= 0; i--) {
                                console.log(data[i]);
                                summ1 = summ1 + Math.floor(data[i].Stake);
                                summ2 = summ2 + Math.floor(data[i].Ggr);
                            }
                            console.log(summ1);
                            console.log(summ2);
                            // Calculate and return Ggr percentage
                            return (summ2 / summ1) * 100;
                        },
                    ],
                },
            });
            // Group data in the grid by 'Pais'
            $$('AgentInform').data.group({
                by: 'Pais',
                map: {
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    Stake: ['Stake', 'sum'],
                    StakePromedio: ['StakePromedio', 'sum'],
                    Payout: ['Payout', 'sum'],
                    Bonos: ['Bonos', 'sum'],
                    Ggr: ['Ggr', 'sum'],
                    GgrPorc: ['GgrPorc', 'sum'],
                },
            });
        });
        // Reference to the grid component
        grid = $$('AgentInform');
        // Store the URL for data loading
        var url = grid.data.url;
        // Listen for filter events to update the grid data
        this.on(this.app, 'informeGerencial:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            // Iterate through filter data entries
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        // Add other filter parameters to query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle object type filter values
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        // Iterate through nested filter entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Clear existing grid data
            grid.clearAll();
            // Load new data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
        });
        // Attach an event handler for item clicks in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            // Trigger an event with the item's ID
            this.$scope.app.callEvent('user:id', [item.Id]);
        });
        // Listen for player selection events to filter grid data
        this.on(this.app, 'player:select', (Id) => {
            // Load grid data filtered by PlayerId
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
